import { render } from "./Error403.vue?vue&type=template&id=fadd9688&scoped=true"
import script from "./Error403.vue?vue&type=script&lang=js"
export * from "./Error403.vue?vue&type=script&lang=js"

import "./Error403.vue?vue&type=style&index=0&id=fadd9688&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadd9688"]])

export default __exports__